"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerFooter = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _layout = require("../../../layout");
var _datePickerTheme = require("./datePickerTheme");
const shouldForwardProp = propName => propName !== "themeMode";
const DatePickerFooter = (0, _styled.default)(_layout.Spacer, {
  shouldForwardProp
})`
    justify-content: center;
    margin-top: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _datePickerTheme.datePickerTheme.footer.marginTop[themeMode];
}};
`;
exports.DatePickerFooter = DatePickerFooter;
//# sourceMappingURL=DatePickerFooter.js.map